import { axiosConfig } from "@/services/axiosConfig";
import { toAbsoluteApiUrl } from "@/lib/toAbsoluteApiUrl";

/**
 * Path suitable for axios (relative to VITE_API_BASE_URL or absolute URL).
 */
function getApiPathForAxios(fileUrl: string): string {
  const trimmed = fileUrl.trim();
  const base = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") ?? "";
  if (base && trimmed.startsWith(base)) {
    const p = trimmed.slice(base.length);
    return p.startsWith("/") ? p : `/${p}`;
  }
  if (trimmed.startsWith("/")) {
    return trimmed;
  }
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }
  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
}

/**
 * Download a file using the authenticated axios client (Bearer + tenant headers).
 * Use this instead of <a href target=_blank> when the file API requires auth —
 * a plain navigation does not send Authorization.
 */
export async function downloadFileWithAuth(
  fileUrl: string | undefined | null,
  filename: string
): Promise<void> {
  if (!fileUrl?.trim()) {
    throw new Error("No file URL");
  }
  const absolute = toAbsoluteApiUrl(fileUrl) ?? fileUrl;
  const path = getApiPathForAxios(absolute);
  const res = await axiosConfig.get(path, { responseType: "blob" });
  const blob =
    res.data instanceof Blob
      ? res.data
      : new Blob([res.data as BlobPart], { type: "application/octet-stream" });
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}
